import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";
import authStateReducer from "modules/auth/user/reducer";
import { forumStateReducer } from "modules/forum/reducer";
import { newsStateReducer } from "modules/news/reducer";
import { examStateReducer } from "modules/exam/reducer";
import { examQuizStateReducer } from "modules/exam/examQuiz/reducer";

export default history =>
  combineReducers({
    router: connectRouter(history),
    authState: authStateReducer,
    forumState: forumStateReducer,
    newsState: newsStateReducer,
    examState: examStateReducer,
    examQuizState: examQuizStateReducer
  });
